import { render } from "./TuitionFreeEducationBlog.vue?vue&type=template&id=4b1d776b&scoped=true"
import script from "./TuitionFreeEducationBlog.vue?vue&type=script&lang=js"
export * from "./TuitionFreeEducationBlog.vue?vue&type=script&lang=js"

import "./TuitionFreeEducationBlog.vue?vue&type=style&index=0&id=4b1d776b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1d776b"]])

export default __exports__